module.exports = __webpack_public_path__ + "img/benefit-05-iot-2.9c83da0f.png";